export default __webpack_public_path__ + "static/media/Group26.95ba6e7f.png";